exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.disabled[data-v-5723e25e]{opacity:1%}.clickable[data-v-5723e25e]{cursor:pointer;background-color:#007baa;color:#fff}.plate[data-v-5723e25e]{margin:3px;padding:5px 7px;border-radius:5px}.plate.uzywany[data-v-5723e25e]{background-color:green}.md-icon.info[data-v-5723e25e]{color:#dda50c}.accent[data-v-5723e25e]{background-color:#8f2f0a}", ""]);

// exports
